<template>
  <router-link :to="{ name: 'Product', params: { slug: product.slug } }" class="gallery-item archFx product-link">
    <div class="archFx item-content">
      <div class="appCover custom archFx" :style="backgroundStyle"></div>
    </div>
    <div class="archFx item-header card-container">
      
      <h3 class="archTitle">{{ product.name }}</h3>
      <div class="tag card-container"> 
        <span  v-for="category in filteredCategories" :key="category" class="tag-item">
          <div class="fas fa-circle custom">
            {{ category }}
          </div>
        </span>
        <span  v-if="product.annotated=='yes'" class="tag-item">
          <div class="fas fa-circle custom">Annotated </div>
        </span> 
      </div>
      <div class="gallery-container solutions archTeaser">
        <p class="text-justify word-wrap no-h1-h2-h3 product-overview" v-html="product.overview.length > 50
      ? product.overview.slice(0, 100) + '...'
      : product.overview
    "></p>
      </div>
    </div>
  </router-link>
</template>

<script>
import Rating from "@/components/Rating";

export default {
  name: "AppCard",
  props: ["product"],
  components: { rating: Rating },
  computed: {
  backgroundStyle() {
    const imageUrl = this.$options.filters.media(this.product.logo.slug, {
      width: 700,
      crop: "box"
    });
    return {
      backgroundImage: `url('${imageUrl}')`
    };
  },
  filteredCategories() {
    const modalities = ['mri', 'xray', 'ct', 'eeg', 'ecg'];
    const organs = ['lung', 'heart', 'liver', 'arteries', 'trachea', 'spine', 'pancreas', 'spleen', 'kidneys', 'intestines', 'bone', 'breast', 'teeth'];
    const pathologies = ['healthy', 'covid', 'nodule', 'masse', 'fibrosis', 'emphysma', 'pulmonary interstitial disease', 'dilated heart', 'thormbus', 'atheroma', 'dissection', 'aneurysm', 'pulmonary disease', 'arterial disease', 'heart disease'];
    
    const allCategories = this.product.categories;
    const selectedCategories = {
      modalities: null,
      organs: null,
      bodyRegions: null,
      pathologies: []
    };

      for (let category of allCategories) {
        if (modalities.includes(category) && !selectedCategories.modalities) {
          selectedCategories.modalities = category;
        } else if (organs.includes(category) && !selectedCategories.organs) {
          selectedCategories.organs = category;
        } else if (pathologies.includes(category)) {
          selectedCategories.pathologies.push(category);
        }
      }

        if (selectedCategories.pathologies.length > 3) {
          selectedCategories.pathologies = selectedCategories.pathologies.slice(0, 3); 
        }
    
      return [
        selectedCategories.modalities,
        selectedCategories.organs,
        selectedCategories.bodyRegions,
        ...selectedCategories.pathologies
      ].filter(Boolean);
    }
  }
};
</script>
<style scoped>
.product-link .product-overview {
  display: none;
}

.product-link .archTitle{
  display: block ;
  margin-top: 0px!important;
}

.product-link:hover .product-overview {
  opacity: 1;
  display: block;
  position: relative;
  transition: opacity 0.3s ease;
  z-index: 1;
}

.fas.fa-circle.custom {
  padding: 0%;
  padding-right: 0px;
}

.gallery-container.solutions .tag {
  position: relative;
  padding: 0;
}

.product-link .gallery-container.solutions {
  overflow: hidden;
}

.product-link:hover .gallery-container.solutions {
  height: 100px; 
}

</style>


// WEBPACK FOOTER //
// src/components/AppCard.vue